import React from "react";
import {
  ServiceAddVkiModal,
  ServiceAddEgfrModal,
  ProcessDirectionModal,
  AskDoctorModal,
  PregnantControlModal,
  HIVModal,
  PacemakerModal,
  LabRequestModal,
  InvestigationRequestNoteModal,
  ServiceAddKonstrastModal,
  ServiceRequestKonstrastModal,
  ConsultationModal,
  PathologyModal,
} from "src/components/Add-Service-Modals";
import { ResolvedWillOpenCard } from "../../helpers/willOpenCardHelper";

export interface WillOpenCardModalsProps {
  // Patient info
  rowID: string;
  title: string;

  // Modal open states
  openHeightInfoModal: boolean;
  openVkiModal: boolean;
  openEgfrModal: boolean;
  openProcessDirectionModal: boolean;
  openDirectionModal: boolean;
  openAskDoctorModal: boolean;
  openPregnantControlModal: boolean;
  openPregnantModal: boolean;
  openHivModal: boolean;
  openPacemakerModal: boolean;
  openLabModal: boolean;
  openInvestigationModal: boolean;
  openContrastModal: boolean;
  openContrastRequestModal: boolean;
  openConsultationModal: boolean;
  openPathologyModal: boolean;

  // State setters for pendingAddToPatient flow
  setOpenVkiModal: (val: boolean) => void;
  setOpenEgfrModal: (val: boolean) => void;
  setOpenDirectionModal: (val: boolean) => void;
  setOpenAskDoctorModal: (val: boolean) => void;
  setOpenPregnantModal: (val: boolean) => void;
  setOpenHivModal: (val: boolean) => void;
  setOpenPacemakerModal: (val: boolean) => void;
  setOpenLabModal: (val: boolean) => void;
  setOpenInvestigationModal: (val: boolean) => void;
  setOpenContrastModal: (val: boolean) => void;
  setOpenContrastRequestModal: (val: boolean) => void;
  setOpenConsultationModal: (val: boolean) => void;
  setOpenPathologyModal: (val: boolean) => void;
  setPendingAddToPatient: (val: boolean) => void;

  // WillOpenCard flow state
  activeWillOpenCardIndex: number | null;
  activeWillOpenCardServiceName: string | undefined;
  pendingWillOpenCards: ResolvedWillOpenCard[];

  // Handlers
  handleWillOpenCardModalCancelled: () => void;
  handleWillOpenCardModalClosed: () => void;
  upsertAddInfoForPendingService: (key: string, data: any, explicitServiceId?: number | string) => void;

  // PendingAddToPatient handlers
  handleVkiModalSave: (data?: any) => void;
  handleEgfrModalSave: (data?: any) => void;
  handleDirectionSave: (directionLabel: string) => void;
  handleAskDoctorSave: (data: any) => void;
  handlePregnantSave: (value: string) => void;
  handleHivSave: (value: string) => void;
  handlePacemakerSave: (value: string) => void;
  handleLabSave: (value: string) => void;
  handleInvestigationSave: (note: string) => void;
}

const WillOpenCardModals: React.FC<WillOpenCardModalsProps> = ({
  rowID,
  title,
  openHeightInfoModal,
  openVkiModal,
  openEgfrModal,
  openProcessDirectionModal,
  openDirectionModal,
  openAskDoctorModal,
  openPregnantControlModal,
  openPregnantModal,
  openHivModal,
  openPacemakerModal,
  openLabModal,
  openInvestigationModal,
  openContrastModal,
  openContrastRequestModal,
  openConsultationModal,
  openPathologyModal,
  setOpenVkiModal,
  setOpenEgfrModal,
  setOpenDirectionModal,
  setOpenAskDoctorModal,
  setOpenPregnantModal,
  setOpenHivModal,
  setOpenPacemakerModal,
  setOpenLabModal,
  setOpenInvestigationModal,
  setOpenContrastModal,
  setOpenContrastRequestModal,
  setOpenConsultationModal,
  setOpenPathologyModal,
  setPendingAddToPatient,
  activeWillOpenCardIndex,
  activeWillOpenCardServiceName,
  pendingWillOpenCards,
  handleWillOpenCardModalCancelled,
  handleWillOpenCardModalClosed,
  upsertAddInfoForPendingService,
  handleVkiModalSave,
  handleEgfrModalSave,
  handleDirectionSave,
  handleAskDoctorSave,
  handlePregnantSave,
  handleHivSave,
  handlePacemakerSave,
  handleLabSave,
  handleInvestigationSave,
}) => {
  return (
    <>
      {/* willopencard modalları */}
      <ServiceAddVkiModal
        open={openHeightInfoModal || openVkiModal}
        onClose={
          openHeightInfoModal
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenVkiModal(false);
                setPendingAddToPatient(false);
              }
        }
        patientId={rowID ? parseInt(rowID, 10) : undefined}
        onSave={(data: any) => {
          if (openHeightInfoModal) {
            // willopencard akışı - veri kontrolü
            const hasValidData = data?.height || data?.weight || data?.bmi || data?.psychStatus || data?.maritalStatus;
            if (!hasValidData) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            upsertAddInfoForPendingService("HEIGHT_INFO", {
              Height: data?.height ? Number(data.height) : null,
              Weight: data?.weight ? Number(data.weight) : null,
              VKI: data?.bmi ? Number(data.bmi) : null,
              PsychologicalStatusId: data?.psychStatus
                ? Number(data.psychStatus)
                : null,
              MarriageId: data?.maritalStatus
                ? Number(data.maritalStatus)
                : null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handleVkiModalSave(data);
          }
        }}
      />
      <ServiceAddEgfrModal
        open={openEgfrModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenEgfrModal(false);
                setPendingAddToPatient(false);
              }
        }
        patientId={rowID ? parseInt(rowID, 10) : undefined}
        onSave={(data: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı - veri kontrolü
            const hasValidData = data?.height && data?.muscleFactor;
            if (!hasValidData) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            upsertAddInfoForPendingService("EGFR", {
              Height: data?.height ? Number(data.height) : null,
              PatientMuscleFactor: data?.muscleFactor
                ? Number(data.muscleFactor)
                : null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handleEgfrModalSave(data);
          }
        }}
      />
      <ProcessDirectionModal
        open={openProcessDirectionModal || openDirectionModal}
        onClose={
          openProcessDirectionModal
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenDirectionModal(false);
                setPendingAddToPatient(false);
              }
        }
        serviceName={
          activeWillOpenCardServiceName || title || "Seçilen Hizmet Adı"
        }
        onSave={(directionLabel: any) => {
          if (openProcessDirectionModal) {
            // willopencard akışı - veri kontrolü
            if (!directionLabel || !directionLabel.trim()) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            const normalized = (directionLabel || "").toLowerCase();
            let olrId: number | null = null;
            if (normalized.includes("sağ") && !normalized.includes("sol")) {
              olrId = 1;
            } else if (normalized.includes("sol") && !normalized.includes("sağ")) {
              olrId = 2;
            } else if (normalized) {
              olrId = 3;
            }
            upsertAddInfoForPendingService("PROCESS_DIRECTION", {
              OlrId: olrId,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handleDirectionSave(directionLabel);
          }
        }}
      />
      <AskDoctorModal
        open={openAskDoctorModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenAskDoctorModal(false);
                setPendingAddToPatient(false);
              }
        }
        serviceName={
          activeWillOpenCardServiceName || title || "Seçilen Hizmet Adı"
        }
        onSave={(data: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı - veri kontrolü
            const hasValidData = data?.arrivalType || data?.departmentName || data?.doctorName || data?.referenceDoctor || data?.assistantDoctor || data?.referringPersonnel;
            if (!hasValidData) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            const cardKey =
              activeWillOpenCardIndex !== null &&
              pendingWillOpenCards[activeWillOpenCardIndex]
                ? pendingWillOpenCards[activeWillOpenCardIndex].key
                : "ASK_DOCTOR_REQUEST";
            upsertAddInfoForPendingService(cardKey, {
              PatientTypeId: data?.arrivalType
                ? Number(data.arrivalType)
                : null,
              DeptId: data?.departmentName
                ? Number(data.departmentName)
                : null,
              DoctorId: data?.doctorName ? Number(data.doctorName) : null,
              RefDoctorId: data?.referenceDoctor
                ? Number(data.referenceDoctor)
                : null,
              AssistantDoctorId: data?.assistantDoctor
                ? Number(data.assistantDoctor)
                : null,
              RefPersonelId: data?.referringPersonnel
                ? Number(data.referringPersonnel)
                : null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handleAskDoctorSave(data);
          }
        }}
      />
      <PregnantControlModal
        open={openPregnantControlModal || openPregnantModal}
        onClose={
          openPregnantControlModal
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenPregnantModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(pregInfo: any) => {
          if (openPregnantControlModal) {
            // willopencard akışı - veri kontrolü
            if (!pregInfo || pregInfo === "" || pregInfo === null || pregInfo === undefined) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            // pregInfo zaten ID olarak geliyor ("0", "1", "2" gibi), direkt kullan
            const code: string | null = pregInfo ? String(pregInfo) : null;
            upsertAddInfoForPendingService("PREGNANT_CONTROL", {
              PregnantOrLactation: code,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handlePregnantSave(pregInfo);
          }
        }}
      />
      <HIVModal
        open={openHivModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenHivModal(false);
                setPendingAddToPatient(false);
              }
        }
        serviceName={
          activeWillOpenCardServiceName || title || "Seçilen Hizmetin Adı"
        }
        onSave={(processInfo: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı - veri kontrolü
            if (!processInfo || processInfo === "" || processInfo === null || processInfo === undefined) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            upsertAddInfoForPendingService("HIV", {
              HivInfoId: processInfo ? Number(processInfo) : null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handleHivSave(processInfo);
          }
        }}
      />
      <PacemakerModal
        open={openPacemakerModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenPacemakerModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(val: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı - veri kontrolü
            if (!val || val === "" || val === null || val === undefined) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            // val zaten ID olarak geliyor ("1", "0" gibi), direkt kullan
            const code: string | null = val ? String(val) : null;
            upsertAddInfoForPendingService("PACEMAKER_CONTROL", {
              PacemakerControl: code,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handlePacemakerSave(val);
          }
        }}
      />
      <LabRequestModal
        open={openLabModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenLabModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(sampleRegion: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı - veri kontrolü
            if (!sampleRegion || sampleRegion === "" || sampleRegion === null || sampleRegion === undefined) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            upsertAddInfoForPendingService("LAB_REQUEST", {
              LabSampleTakenSiteId: sampleRegion ? Number(sampleRegion) : null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handleLabSave(sampleRegion);
          }
        }}
      />
      <InvestigationRequestNoteModal
        open={openInvestigationModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenInvestigationModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(note: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı - veri kontrolü
            // Note boş olabilir, bu yüzden sadece null/undefined kontrolü yapıyoruz
            // Ama eğer zorunlu ise, boş string kontrolü de eklenebilir
            upsertAddInfoForPendingService("EXAMINATION_REQUEST", {
              ExaminationNote: note || null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı
            handleInvestigationSave(note);
          }
        }}
      />
      <ServiceAddKonstrastModal
        open={openContrastModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenContrastModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(data: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı
            upsertAddInfoForPendingService("CONTRAST", {
              IsContrasted: data?.iscontrasted ?? null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı - bu akış için handler eklenebilir
          }
        }}
        serviceName={
          activeWillOpenCardServiceName || title || "Seçilen Hizmet Adı"
        }
      />
      <ServiceRequestKonstrastModal
        open={openContrastRequestModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenContrastRequestModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(data: any) => {
          if (activeWillOpenCardIndex !== null) {
            // willopencard akışı - veri kontrolü
            if (data?.iscontrasted === null || data?.iscontrasted === undefined) {
              // Veri doldurulmamış, hizmet seçimini geri al
              handleWillOpenCardModalCancelled();
              return;
            }
            upsertAddInfoForPendingService("CONTRAST", {
              IsContrasted: data?.iscontrasted ?? null,
            });
            handleWillOpenCardModalClosed();
          } else {
            // pendingAddToPatient akışı - bu akış için handler eklenebilir
          }
        }}
        serviceName={
          activeWillOpenCardServiceName || title || "Seçilen Hizmet Adı"
        }
      />
      <ConsultationModal
        open={openConsultationModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenConsultationModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(data: any) => {
           if (activeWillOpenCardIndex !== null) {
               // willopencard akışı
               const cardKey = "CONSULTATION";
               upsertAddInfoForPendingService(cardKey, {
                 ConsultationNote: data?.notes || null,
                 ConsultationDoctorId: data?.doctor ? Number(data.doctor) : null
               });
            handleWillOpenCardModalClosed();
          } else {
             // pendingAddToPatient akışı handler (if needed)
          }
        }}
      />
      <PathologyModal
        open={openPathologyModal}
        onClose={
          activeWillOpenCardIndex !== null
            ? handleWillOpenCardModalCancelled
            : () => {
                setOpenPathologyModal(false);
                setPendingAddToPatient(false);
              }
        }
        onSave={(data: any) => {
           if (activeWillOpenCardIndex !== null) {
            const cardKey =
                 activeWillOpenCardIndex !== null &&
                 pendingWillOpenCards[activeWillOpenCardIndex]
                   ? pendingWillOpenCards[activeWillOpenCardIndex].key
                   : "PATHOLOGY_REQUEST";

            upsertAddInfoForPendingService(cardKey, {
               Description: data?.description || null,
               Material: data?.material || null,
               Localization: data?.localization || null,
               ClinicalInfo: data?.clinicalInfo || null
            });
            handleWillOpenCardModalClosed();
          }
        }}
      />
    </>
  );
};

export default WillOpenCardModals;
